import React from 'react';
import { NavLink } from 'react-router-dom';
import '../CSS/Navbar.css';


const Navbar = () => {
    return (
       <>
            <nav class="navbar navbar-expand-lg navbar-dark bg-light">
                <div className='container'>
                    <div className="navbar-brand logo"> Provider</div>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                        </button>
                    <div class="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul class="navbar-nav ml-auto mb-2 mb-lg-0">
                                <li className="nav-item">
                                    <NavLink activeClassName="menu_active" exact className="nav-link active" aria-current="page" to="/">Home</NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink activeClassName="menu_active" exact className="nav-link active" to="/about">about</NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink activeClassName="menu_active" exact className="nav-link active" to="/skill">skill</NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink activeClassName="menu_active" exact className="nav-link active" to="/project">project</NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink activeClassName="menu_active" exact className="nav-link active" to="contact">contact</NavLink>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>
                    
                
       </>
    )
}

export default Navbar;
